<template>
  <sidebar
    :addTitle="$t('Drilling.Holes.AddNew')"
    :editTitle="$t('Drilling.Holes.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col  vs-w="12">
            <ValidationProvider :name="$t('Drilling.Holes.Code')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.Code')"
                v-model="holeCode"
                name="code"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.DrillHoleTypes.Name')}}</form-label>
            <v-select
              label="name"
              :options="drillHoleTypeEnum"
              :reduce="type => type.id"
              v-model="holeDrillHoleType"
              class="w-full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.ExpenseTypes.Name')}}</form-label>
            <v-select
              label="name"
              :options="expenseTypesEnum"
              :reduce="type => type.id"
              v-model="holeExpenseType"
              class="w-full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.CoordinateSystemTypes.Name')}}</form-label>
            <v-select
              label="name"
              :options="coordinateSystemTypes"
              :reduce="type => type.id"
              v-model="holeCoordinateSystemType"
              class="w-full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.DrillingTypes.Name')}}</form-label>
            <v-select
              label="name"
              :options="drillingTypeEnum"
              :reduce="type => type.id"
              v-model="holeDrillingType"
              class="w-full"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.RigTransportTypes.Name')}}</form-label>
            <v-select
              label="name"
              :options="rigTransportTypeEnum"
              :reduce="type => type.id"
              v-model="holeRigTransportType"
              class="w-full"
            />
          </vs-col>
        </vs-row>
         <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
             <ValidationProvider :name="$t('Drilling.Holes.StartMeters')" rules="required|decimal:2|between:0,1000000" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.StartMeters')"
                v-model="holeStartMeters"
                name="startMeters"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
             <ValidationProvider :name="$t('Drilling.Holes.TargetDepth')" rules="required|decimal:2|between:0,1000000" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.TargetDepth')"
                v-model="holeTargetDepth"
                name="targetDepth"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <!-- <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Drilling.Holes.Easting')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.Easting')"
                v-model="holeEasting"
                name="easting"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Drilling.Holes.Northing')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.Northing')"
                v-model="holeNorthing"
                name="northing"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Drilling.Holes.CollarAzimuth')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.CollarAzimuth')"
                v-model="holeCollarAzimuth"
                name="collarAzimuth"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Drilling.Holes.CollarDip')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.CollarDip')"
                v-model="holeCollarDip"
                name="collarDip"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Drilling.Holes.LiftRate')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.LiftRate')"
                v-model="holeLiftRate"
                name="liftRate"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Drilling.Holes.DriftRate')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.DriftRate')"
                v-model="holeDriftRate"
                name="driftRate"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Drilling.Holes.Distance')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.Distance')"
                v-model="holeDistance"
                name="distance"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Drilling.Holes.Extension')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.Extension')"
                v-model="holeExtension"
                name="extension"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row> -->
        <vs-divider class="mb-0">{{$t('Drilling.Holes.Target')}}</vs-divider>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <form-label>{{$t('Drilling.Holes.TargetZone')}}</form-label>
            <v-select
              label="name"
              :options="filteredZones"
              :reduce="zone => zone.zoneId"
              v-model="holeTargetZoneId"
              class="w-full"
            />
          </vs-col>
        </vs-row>
        <!-- <vs-row >
          <vs-col vs-w="6" class="mr-5">
            <ValidationProvider :name="$t('Drilling.Holes.TargetDepth')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.TargetDepth')"
                v-model="holeTargetDepth"
                name="holeTargetDepth"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="5">
            <ValidationProvider :name="$t('Drilling.Holes.TargetPriority')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('Drilling.Holes.TargetPriority')"
                v-model="holeTargetPriority"
                name="extension"
              ></validated-input>
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row> -->
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../shared/components";

import CoordinateSystemTypeEnum from './../../CoordinateSystemTypeEnum.js';
import DrillHoleTypeEnum from './../../DrillHoleTypeEnum.js';
import ExpenseTypeEnum from '../../ExpenseTypeEnum';
import DrillingTypeEnum from './../../DrillingTypeEnum';
import RigTransportTypeEnum from './../../RigTransportTypeEnum';
import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    zones: {
      type: Array,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    'v-select': vSelect
  },
  data() {
    return {
      holeHoleId: 0,
      holeProjectId: 0,
      holeCode: "N/A",
      holeDrillHoleType: null,
      holeExpenseType: null,
      holeCoordinateSystemType: null,
      holeEasting: null,
      holeNorthing: null,
      holeCollarAzimuth: null,
      holeCollarDip: null,
      holeLiftRate: null,
      holeDriftRate: null,
      holeDistance: null,
      holeExtension: null,
      holeTargetZoneId: null,
      holeTargetDepth: 0,
      holeTargetPriority: null,
      holeComments:'',
      holeStatus: '',
      holeStartMeters: 0,
      holeDrillingType: null,
      holeRigTransportType: null,
      drillHoleTypeEnum: [
        { id:DrillHoleTypeEnum.Conversion, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Conversion) },
        { id:DrillHoleTypeEnum.Extension, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Extension) },
        { id:DrillHoleTypeEnum.Exploration, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Exploration) },
        { id:DrillHoleTypeEnum.Geotechnical, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Geotechnical) },
        { id:DrillHoleTypeEnum.Delineation, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Delineation) },
        { id:DrillHoleTypeEnum.Definition, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Definition) },
        { id:DrillHoleTypeEnum.ServiceHole, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.ServiceHole) },
        { id:DrillHoleTypeEnum.Unknown, name: this.$t("Drilling.DrillHoleTypes." + DrillHoleTypeEnum.Unknown) }
      ],
      expenseTypesEnum: [
        { id:ExpenseTypeEnum.CapitalizeGrowth, name: this.$t("Drilling.ExpenseTypes." + ExpenseTypeEnum.CapitalizeGrowth) },
        { id:ExpenseTypeEnum.CapitalizeSustaining, name: this.$t("Drilling.ExpenseTypes." + ExpenseTypeEnum.CapitalizeSustaining) },
        { id:ExpenseTypeEnum.Expense, name: this.$t("Drilling.ExpenseTypes." + ExpenseTypeEnum.Expense) },
        { id:ExpenseTypeEnum.Operating, name: this.$t("Drilling.ExpenseTypes." + ExpenseTypeEnum.Operating) }
      ],
      drillingTypeEnum: [
        { id:DrillingTypeEnum.DiamondDrill, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.DiamondDrill) },
        { id:DrillingTypeEnum.Directional, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.Directional) },
        { id:DrillingTypeEnum.DownTheHoleHammer, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.DownTheHoleHammer) },
        { id:DrillingTypeEnum.RotaryAirBlast, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.RotaryAirBlast) },
        { id:DrillingTypeEnum.ReverseCirculation, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.ReverseCirculation) },
        { id:DrillingTypeEnum.Sludge, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.Sludge) },
        { id:DrillingTypeEnum.Soil, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.Soil) },
        { id:DrillingTypeEnum.Sonic, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.Sonic) },
        { id:DrillingTypeEnum.BlastHole, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.BlastHole) },
        { id:DrillingTypeEnum.Unknown, name: this.$t("Drilling.DrillingTypes." + DrillingTypeEnum.Unknown) }
      ],
      rigTransportTypeEnum: [
        { id:RigTransportTypeEnum.SkidDrill, name: this.$t("Drilling.RigTransportTypes." + RigTransportTypeEnum.SkidDrill) },
        { id:RigTransportTypeEnum.FlyDrill, name: this.$t("Drilling.RigTransportTypes." + RigTransportTypeEnum.FlyDrill) }
      ],
      coordinateSystemTypes: [
        { id:CoordinateSystemTypeEnum.UTMNAD83Zone17N, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.UTMNAD83Zone17N) },
        { id:CoordinateSystemTypeEnum.UpperCanadaGeoGrid, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.UpperCanadaGeoGrid) },
        { id:CoordinateSystemTypeEnum.UpperBeaverGeologyGrid, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.UpperBeaverGeologyGrid) },
        { id:CoordinateSystemTypeEnum.UTMNAD83Zone14, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.UTMNAD83Zone14) },
        { id:CoordinateSystemTypeEnum.UTMNAD83Zone15, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.UTMNAD83Zone15) },
        { id:CoordinateSystemTypeEnum.Unknown, name: this.$t("Drilling.CoordinateSystemTypes." + CoordinateSystemTypeEnum.Unknown) }
      ]
    };
  },
  computed : {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    filteredZones() {
      // only return savec zones
      return this.zones.filter(z => z.zoneId !== 0)
    }

  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {holeId, projectId, code, drillHoleType, expenseType, drillingType, rigTransportType, coordinateSystemType, easting, northing, collarAzimuth, collarDip, liftRate, driftRate, distance, extension, targetZoneId, targetDepth, targetPriority, comments, status, startMeters} = JSON.parse(JSON.stringify(this.data));
      this.holeHoleId = holeId;
      this.holeProjectId = projectId;
      this.holeCode = code;
      this.holeDrillHoleType = drillHoleType;
      this.holeExpenseType = expenseType;
      this.holeCoordinateSystemType = coordinateSystemType;
      this.holeEasting = easting;
      this.holeNorthing = northing;
      this.holeCollarAzimuth = collarAzimuth;
      this.holeCollarDip = collarDip;
      this.holeLiftRate = liftRate;
      this.holeDriftRate = driftRate;
      this.holeDistance = distance;
      this.holeExtension = extension;
      this.holeTargetZoneId = targetZoneId;
      this.holeTargetDepth = targetDepth;
      this.holeTargetPriority = targetPriority;
      this.holeComments = comments;
      this.holeStatus = status;
      this.holeStartMeters = startMeters;
      this.holeDrillingType = drillingType;
      this.holeRigTransportType = rigTransportType;

      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.holeId) return;

      this.holeHoleId = 0;
      this.holeProjectId = 0;
      this.holeCode = 'N/A';
      this.holeDrillHoleType = null;
      this.holeExpenseType = null;
      this.holeCoordinateSystemType = null;
      this.holeEasting = null;
      this.holeNorthing = null;
      this.holeCollarAzimuth = null;
      this.holeCollarDip = null;
      this.holeLiftRate = null;
      this.holeDriftRate = null;
      this.holeDistance = null;
      this.holeExtension = null;
      this.holeTargetZoneId = null;
      this.holeTargetDepth = 0;
      this.holeTargetPriority = null;
      this.holeComments = '';
      this.holeStatus = '';
      this.holeStartMeters = 0;
      this.holeDrillingType = null;
      this.holeRigTransportType = null;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            holeId : this.holeHoleId, 
            projectId : this.holeProjectId, 
            code : this.holeCode, 
            drillHoleType : this.holeDrillHoleType, 
            expenseType : this.holeExpenseType,
            coordinateSystemType : this.holeCoordinateSystemType, 
            easting : this.holeEasting, 
            northing : this.holeNorthing, 
            collarAzimuth : this.holeCollarAzimuth, 
            collarDip : this.holeCollarDip, 
            liftRate : this.holeLiftRate, 
            driftRate : this.holeDriftRate, 
            distance : this.holeDistance, 
            extension : this.holeExtension, 
            targetZoneId : this.holeTargetZoneId, 
            targetDepth : this.holeTargetDepth, 
            targetPriority : this.holeTargetPriority, 
            comments : this.holeComments, 
            status : this.holeStatus, 
            startMeters : this.holeStartMeters,
            drillingType : this.holeDrillingType,
            rigTransportType : this.holeRigTransportType
          };

          if (this.holeHoleId !== null && this.holeHoleId > 0) {
            this.$emit("onHoleUpdated", obj);
          } else {
            this.$emit("onHoleInserted", obj);
          }
        }
      });
    }
  }
};
</script>
